module.exports = __webpack_public_path__ + "img/custom_client_seed_2_ru.b9fc8ad9.png";